import { useLocation } from "react-router-dom";

// Cribbed whole cloth from the docs
// https://reactrouter.com/web/example/query-parameters
export function useQuery() {
  return new URLSearchParams(useLocation().search);
}
